<template>
    <div>
        <!-- 关联问题 -->
        <el-table :data="detail.toProblem">
            <el-table-column label="编号" prop="serialNumber"></el-table-column>
            <el-table-column label="标题" prop="title">
                <template slot-scope="scope">
                    <el-button type="text" @click="toCorrectDetail(scope.row.serialNumber)">{{scope.row.title}}</el-button>
                </template>
            </el-table-column>

            <el-table-column label="问题分类" >
                <template slot-scope="scope">
                    {{ scope.row.category | tableVal(problemList,'t') }}
                </template>
            </el-table-column>
            <el-table-column label="报告人" prop="requester"></el-table-column>
            <el-table-column label="指派人" prop="designator"></el-table-column>
            <el-table-column label="创建时间" prop="createTime"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        props:{
            detail:Object,
            problemList:Array
        },
        data() {
            return {

            }
        },
        created() {
            // console.log(this.problemList,'problemList');
        },
        methods: {
            //点击待办或请求中列表名称时跳转对应详情
            toCorrectDetail(val){
                this.$router.push({path:'/problemDetail',query:{serialNumber:val}})
            },
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
